// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { componentWithCondition } from '@atlaskit/platform-feature-flags-react';

import { LoadableBackground, LoadableAfterPaint } from '@confluence/loadable';
import { expValEquals } from '@confluence/feature-experiments';
import type { FC } from 'react';
import type { EditorHelpCenterProps } from './EditorHelpCenter.tsx';

export type { EditorHelpCenterProps } from './EditorHelpCenter.tsx';

const EditorHelpCenterBackground = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-EditorHelpCenter" */ './EditorHelpCenter.tsx'))
			.EditorHelpCenter,
});

const EditorHelpCenterOnPaint = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-EditorHelpCenter" */ './EditorHelpCenter.tsx'))
			.EditorHelpCenter,
});

export const EditorHelpCenter: FC<
	EditorHelpCenterProps & {
		children?: any;
	}
> = componentWithCondition(
	() => expValEquals('platform_editor_help_center_background_load', 'variant', 'test'),
	EditorHelpCenterBackground,
	EditorHelpCenterOnPaint,
);
